import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation, registerQuery } from '@adornis/baseql/metadata/register.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { checkAbacOnViewedUserMiddleware } from '../../permissions/middlewares/checkAbacOnViewedUserMiddleware.js';
import { UserDetailsActions } from '../../users/details/UserDetailsPolicy.js';
import { Quittung } from '../entities/Quittung.js';
import { resolveGenerateQuittungPDF } from '../server/resolvers/resolveGenerateQuittungPDF.js';
import { resolveGetQuittungenForUserID } from '../server/resolvers/resolveGetQuittungenForUserID.js';

/**
 * The person themselves, or whoever may open their Quittungen tab — the same action the tab is gated by.
 */
const canViewQuittungenOf = checkAbacOnViewedUserMiddleware(UserDetailsActions.VIEW_SEPA_MANDATES, 'userID');

const generateQuittungPDF = registerMutation({
  operationName: 'generateQuittungPDF',
  type: () => AdornisFile,
  params: [
    { name: 'userID', type: () => ID },
    { name: 'quittungID', type: () => ID },
    { type: () => String, name: 'type' },
  ],
  middlewares: [canViewQuittungenOf],
  resolve: resolveGenerateQuittungPDF,
});

const getQuittungenForUserID = registerQuery({
  operationName: 'getQuittungenForUserID',
  type: () => [Quittung],
  params: [{ name: 'userID', type: () => ID }],
  middlewares: [canViewQuittungenOf],
  resolve: resolveGetQuittungenForUserID,
});

export const QuittungenAPI = {
  generatePDF: generateQuittungPDF,
  getForUserID: getQuittungenForUserID,
};
